import React from "react";
import { FormattedMessage } from "react-intl";

import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import { TVehicle } from "types";

import { Tupel } from "components";

interface IFeatures {
  vehicle: TVehicle;
  paperProps?: any;
}

const Features: React.FC<IFeatures> = ({
  vehicle,
  paperProps = {
    variant: "outlined",
    sx: { p: 2 },
  },
}): JSX.Element => {
  const {
    aussenfarbe_beschreibung,
    erstzulassung,
    farbe_aussen,
    kraftstoff,
    gaenge,
    getriebe,
    hubraum,
    km,
    kw,
    metallic,
    mwst_ausweisbar,
    oldtimer,
    partikelfilter,
    sitze,
    tueren,
    unfallwagen,
    zylinder = 0,
  } = vehicle;

  return (
    <Paper {...paperProps}>
      <Typography variant="h5" component="h2">
        <FormattedMessage id="common.data" defaultMessage="Daten" />
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { md: "1fr 1fr" },
          columnGap: 3,
        }}
      >
        {kraftstoff && kraftstoff.id && (
          <Tupel
            labelId="filter.kraftstoff.label"
            textId={`kraftstoff.${kraftstoff.id}.label`}
            property="fuelType"
          />
        )}
        {erstzulassung && erstzulassung.length > 0 && (
          <Tupel
            labelId="properties.erstzulassung.label"
            date={erstzulassung}
            property="dateVehicleFirstRegistered
"
          />
        )}
        <div property="vehicleEngine">
          <Tupel
            labelId="properties.leistung.label"
            text={kw ? `${kw} kW (${Math.round(kw * 1.35962)} PS)` : undefined}
            property="enginePower"
          />
        </div>
        <Tupel
          labelId="common.aussenfarbe_beschreibung.label"
          text={aussenfarbe_beschreibung}
        />
        {farbe_aussen && farbe_aussen.id && (
          <Tupel
            labelId="filter.farbe_aussen.label"
            textId={`farbe.${farbe_aussen.id}.label`}
            property="color"
          />
        )}
        {getriebe && getriebe.id && (
          <Tupel
            labelId="filter.getriebe.label"
            textId={`getriebe.${getriebe.id}.label`}
          />
        )}
        <Tupel labelId="properties.gaenge.label" number={gaenge} />
        <Tupel
          force
          labelId="term.umweltplakette"
          label="Umweltplakette"
          text={vehicle.umweltplakette?.name || ""}
        />
        <Tupel labelId="properties.hubraum.label" number={hubraum} unit="cm³" />
        <Tupel labelId="properties.zylinder.label" number={zylinder} />
        <Tupel
          labelId="properties.laufleistung.label"
          number={km}
          unit="km"
          force
        />
        <Tupel labelId="properties.sitze.label" number={sitze} />
        <Tupel labelId="properties.tueren.label" number={tueren} />
        {metallic && (
          <Tupel labelId="properties.metallic.label" boolean={metallic} />
        )}
        {mwst_ausweisbar && (
          <Tupel
            labelId="properties.mwst_ausweisbar.label"
            boolean={mwst_ausweisbar}
          />
        )}
        {oldtimer && (
          <Tupel labelId="properties.oldtimer.label" boolean={oldtimer} />
        )}
        {partikelfilter && (
          <Tupel
            labelId="properties.partikelfilter.label"
            boolean={partikelfilter}
          />
        )}
        {vehicle.hasOwnProperty("unfallwagen") && unfallwagen !== null && (
          <Tupel labelId="properties.unfallwagen.label" boolean={unfallwagen} />
        )}
      </Box>
    </Paper>
  );
};

export default Features;
